// extracted by mini-css-extract-plugin
export default {"container":"HE-z","innerContainer":"IE-z","multipleLines":"JE-z","heading":"KE-z","content":"LE-z","linkColor":"ME-z"};